import { render } from "./CreatePassword.vue?vue&type=template&id=97f38494&scoped=true"
import script from "./CreatePassword.vue?vue&type=script&lang=ts"
export * from "./CreatePassword.vue?vue&type=script&lang=ts"

import "./CreatePassword.vue?vue&type=style&index=0&id=97f38494&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-97f38494"

export default script